/**
 * Mapping des noms Pokémon en français
 * Source: Pokedex officiel français
 */
export const pokemonFrenchNames = {
    1: 'Bulbizarre',
    2: 'Herbizarre',
    3: 'Florizarre',
    4: 'Salamèche',
    5: 'Reptincel',
    6: 'Dracaufeu',
    7: 'Carapuce',
    8: 'Carabaffe',
    9: 'Tortank',
    10: 'Chenipan',
    11: 'Chrysacier',
    12: 'Papilusion',
    13: 'Aspicot',
    14: 'Coconfort',
    15: 'Dardargnan',
    16: 'Roucoups',
    17: 'Roucoupe',
    18: 'Roucarnage',
    19: 'Rattata',
    20: 'Rattatac',
    21: 'Piafabec',
    22: 'Rapasdepic',
    23: 'Abo',
    24: 'Arbok',
    25: 'Pikachu',
    26: 'Raichu',
    27: 'Sabelette',
    28: 'Sablaireau',
    29: 'Nidoran♀',
    30: 'Nidorina',
    31: 'Nidoqueen',
    32: 'Nidoran♂',
    33: 'Nidorino',
    34: 'Nidoking',
    35: 'Mélofée',
    36: 'Félifère',
    37: 'Féliglace',
    38: 'Goupile',
    39: 'Rondoudou',
    40: 'Grodoudou',
    41: 'Nosferapti',
    42: 'Nosferalto',
    43: 'Ortide',
    44: 'Rafflesia',
    45: 'Paras',
    46: 'Parasect',
    47: 'Venonat',
    48: 'Venomoth',
    49: 'Taupe',
    50: 'Psykokwak',
    51: 'Akwakwak',
    52: 'Magnémite',
    53: 'Magneton',
    54: 'Soporifik',
    55: 'Hypnomade',
    56: 'Krabby',
    57: 'Krabboss',
    58: 'Voltorbe',
    59: 'Électrode',
    60: 'Nœunœuf',
    61: 'Nœunœuf',
    62: 'Tarentule',
    63: 'Synchronomie',
    64: 'Abra',
    65: 'Kadabra',
    66: 'Alakazam',
    67: 'Machoc',
    68: 'Machopeur',
    69: 'Machomei',
    70: 'Chétiflor',
    71: 'Boustiflor',
    72: 'Empiflor',
    73: 'Tentacool',
    74: 'Tentacruel',
    75: 'Racaillou',
    76: 'Gronderre',
    77: 'Grolem',
    78: 'Ponyta',
    79: 'Galopa',
    80: 'Canarticho',
    81: 'Psykokwak',
    82: 'Voltorbe',
    83: 'Électrode',
    84: 'Canarticho',
    85: 'Doduo',
    86: 'Dodrio',
    87: 'Otaria',
    88: 'Lamantine',
    89: 'Tadmorv',
    90: 'Tadmorv',
    91: 'Karmooh',
    92: 'Spectro',
    93: 'Revenant',
    94: 'Ectoplasma',
    95: 'Onix',
    96: 'Crustabri',
    97: 'Colossinge',
    98: 'Exeggcute',
    99: 'Exeggutor',
    100: 'Noeunoeuf',
    101: 'Noeunoeuf',
    102: 'Crustabri',
    103: 'Colossinge',
    104: 'Saquedeneu',
    105: 'Saquedeneu',
    106: 'Kraknoix',
    107: 'Kraknoix',
    108: 'Voltorbe',
    109: 'Magnémite',
    110: 'Magneton',
    111: 'Rhinocorne',
    112: 'Rhinoféros',
    113: 'Leveinard',
    114: 'Saquedeneu',
    115: 'Kangourex',
    116: 'Hypotrempe',
    117: 'Hypocéan',
    118: 'Poissirène',
    119: 'Poissoroy',
    120: 'Stari',
    121: 'Staross',
    122: 'M.Mime',
    123: 'Insécateur',
    124: 'Lippoutou',
    125: 'Électrode',
    126: 'Embraseur',
    127: 'Scarabrute',
    128: 'Tauros',
    129: 'Magicarpe',
    130: 'Léviator',
    131: 'Lokhlass',
    132: 'Métamorph',
    133: 'Évoli',
    134: 'Aquali',
    135: 'Voltali',
    136: 'Flammara',
    137: 'Porygon',
    138: 'Amonita',
    139: 'Amonistar',
    140: 'Kabuto',
    141: 'Kabutops',
    142: 'Ptéra',
    143: 'Ronflex',
    144: 'Articouno',
    145: 'Zapdos',
    146: 'Moltres',
    147: 'Minidraco',
    148: 'Draco',
    149: 'Dracolosse',
    150: 'Mewtwo',
    151: 'Mew'
};

/**
 * Récupère le nom français d'un Pokémon
 */
export function getFrenchName(pokedexId, englishName = '') {
    return pokemonFrenchNames[pokedexId] || englishName;
}

/**
 * Type names en français
 */
export const typeNamesFrench = {
    normal: 'Normal',
    fire: 'Feu',
    water: 'Eau',
    electric: 'Électrique',
    grass: 'Plante',
    ice: 'Glace',
    fighting: 'Combat',
    poison: 'Poison',
    ground: 'Sol',
    flying: 'Vol',
    psychic: 'Psy',
    bug: 'Insecte',
    rock: 'Roche',
    ghost: 'Spectre',
    dragon: 'Dragon',
    dark: 'Ténèbres',
    steel: 'Acier',
    fairy: 'Fée'
};

export function getTypeFrench(englishType) {
    return typeNamesFrench[englishType?.toLowerCase()] || englishType;
}
